import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Main } from "../pages/Main/Main";
import { setAuth } from "../store/action/auth/setauth";
import { useDispatch } from "react-redux";
import { RouteWrapper } from "./RoutWrapper";
import { AdminPanel, CasinoInfo } from "../services";
import { setUserInfo } from "../store/action/auth/setuserinfo";
import { setUserBalance } from "../store/action/auth/setuserbalance";
import { Casino } from "../pages/Casino/Casino";
import { Promotions } from "../pages/Promotions/Promotions";
import { Aviator } from "../pages/Aviator/Aviator";
import { Zeplin } from "../pages/Zeplin/Zeplin";
import { SpaceMan } from "../pages/SpaceMan/SpaceMan";
import { MaltbahisCarck } from "../pages/MaltbahisCarck/MaltbahisCarck";
import { Jackpot } from "../pages/Jackpot/Jackpot";
import { Tournaments } from "../pages/Tournaments/Tournaments";
import { Games } from "../pages/Games/Games";
import { LiveCasino } from "../pages/LiveCasino/LiveCasino";
import { CanliTakvim } from "../pages/CanliTakvim/CanliTakvim";
import { BahisTurnament } from "../pages/BahisTurnament/BahisTurnament";
import { useTypeSelector } from "../hooks/useTypeSelector";
import { Live } from "../pages/Live/Live";
import { Sport } from "../pages/Sport/Sport";
// import loadGit from "./accets/images/gif/loader/loader.gif";
import loadGit from "../accets/images/gif/loader/loader.gif";
import { setUserInit } from "../store/action/auth/setuserinit";
import { setFavoritsUser } from "../store/action/favorits/setFavoritsUser";
import { LiveCalendar } from "../pages/LiveCalendar/LiveCalendar";
import { TournamentsSports } from "../pages/TournamentsSports/TournamentsSports";
import { Betconstruct } from "../pages/Betconstruct/Betconstruct";
import { EdgeGaming } from "../pages/EdgeGaming/EdgeGaming";
import { LeapGaming } from "../pages/LeapGaming/LeapGaming";
import { Kiron } from "../pages/Kiron/Kiron";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { ErrorPage } from "../pages/ErrorPage/ErrorPage";

window.Pusher = Pusher;

declare global {
  interface Window {
    Pusher: typeof Pusher;
  }
}

declare global {
  interface Window {
    Echo: any;
  }
}

function RedirectToMain() {
  const language = useTypeSelector(
    (data) => data.settingsReducer.language.languageShort
  );
  return <Navigate to={`/${language}/`} />;
}

const Navigation = () => {
  const bearerToken = localStorage.getItem("token") || "1234";
  const user = useTypeSelector((data) => data.accountInfoReducer.user);

  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  async function getFavoritsGames() {
    const res = await CasinoInfo.favoritGames();
    dispatch(setFavoritsUser(res.data));
  }

  async function userBalance() {
    try {
      const resbalance = await AdminPanel.userBalance();
      dispatch(setUserBalance(resbalance.data));
      dispatch(setAuth("player"));
      getFavoritsGames();
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    } catch (error) {
      console.error(error);
      localStorage.removeItem("token");
    }
  }
  async function userInfo() {
    try {
      const res = await AdminPanel.userInfo();
      dispatch(setUserInfo(res.data));
    } catch (error) {
      localStorage.removeItem("token");
    }
  }

  useEffect(() => {
    const token = localStorage.getItem("token");
    const isAuthenticated = !!token;
    if (isAuthenticated) {
      userBalance();
      userInfo();
    } else {
      dispatch(setUserInit());
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, []);
  const echo = new Echo({
    broadcaster: "pusher",
    key: "b96900e87fe4fad222df",
    cluster: "eu",
    encrypted: true,
    forceTLS: true,
    authEndpoint: "https://casino-api.services/broadcasting/auth",
    auth: { headers: { Authorization: "Bearer " + bearerToken } },
  });
  echo
    .private("user-" + user.api_user_id)
    .listen("BalanceUpdated", (e: { amount: number; amount_bonus: number }) => {
      const amount = e.amount / 100;
      dispatch(
        setUserBalance({
          balance: {
            amount: amount,
            amount_bonus: 0,
            currency: "",
          },
          cryptoBalance: null,
          fiatBalance: null,
          active_bonus: null,
          init: false,
          extra_data: {
            game_token: "",
            softswiss_freespin: false,
            crypto_payment: null,
          },
        })
      );
    });
  return (
    <>
      {loading ? (
        <div className="layout-bc">
          <div className="bc-loader medium ">
            <div className="bc-loader-contain">
              <img src={loadGit} alt="" />
            </div>
          </div>
        </div>
      ) : (
        <Router>
          <Routes>
            <Route
              path={"/:en/sports/pre-match/event-view"}
              element={<RouteWrapper element={<Sport />} />}
            />
            <Route
              path={"/:en/sports/live/event-view"}
              element={<RouteWrapper element={<Live />} />}
            />
            <Route
              path={"/:en"}
              element={<RouteWrapper element={<Main />} />}
            />
            <Route path="/" element={<RedirectToMain />} />
            <Route
              path={"/:en/casino/jackpot"}
              element={<RouteWrapper element={<Jackpot />} />}
            />
            <Route
              path={"/:en/wonderwheel"}
              element={<RouteWrapper element={<MaltbahisCarck />} />}
            />
            <Route
              path={"/:en/casino/tournaments"}
              element={<RouteWrapper element={<Tournaments />} />}
            />
            <Route
              path={"/:en/promotions"}
              element={<RouteWrapper element={<Promotions />} />}
            />
            <Route
              path={"/:en/promotions/all/:id/:name"}
              element={<RouteWrapper element={<Promotions />} />}
            />
            <Route
              path={"/:en/casino/game-view/806666"}
              element={<RouteWrapper element={<Aviator />} />}
            />
            <Route
              path={"/:en/casino/game-view/9010"}
              element={<RouteWrapper element={<Zeplin />} />}
            />
            <Route
              path={"/:en/casino/game-view/400043028"}
              element={<RouteWrapper element={<SpaceMan />} />}
            />
            <Route
              path={"/:en/live-casino/home/-1/All"}
              element={<RouteWrapper element={<LiveCasino />} />}
            />
            <Route
              path={"*"}
              element={<RouteWrapper element={<ErrorPage />} />}
            />
            <Route
              path={"/:en/casino/slots/-1"}
              element={<RouteWrapper element={<Casino />} />}
            />
            <Route
              path={"/:en/games"}
              element={<RouteWrapper element={<Games />} />}
            />
            <Route
              path={"/:en/sports/live-calendar"}
              element={<RouteWrapper element={<CanliTakvim />} />}
            />
            <Route
              path={"/:en/sports/tournaments"}
              element={<RouteWrapper element={<BahisTurnament />} />}
            />
            <Route
              path={"/:en/sports/pre-match/live-calendar"}
              element={<RouteWrapper element={<LiveCalendar />} />}
            />
            <Route
              path={"/:en/sports/pre-match/tournaments"}
              element={<RouteWrapper element={<TournamentsSports />} />}
            />
            <Route
              path={"/:en/virtual-sports/betconstruct"}
              element={<RouteWrapper element={<Betconstruct />} />}
            />
            <Route
              path={"/:en/virtual-sports/ext/game/155000"}
              element={<RouteWrapper element={<EdgeGaming />} />}
            />
            <Route
              path={"/:en/virtual-sports/ext/game/4000235"}
              element={<RouteWrapper element={<LeapGaming />} />}
            />
            <Route
              path={"/:en/virtual-sports/ext/game/40004001"}
              element={<RouteWrapper element={<Kiron />} />}
            />
          </Routes>
        </Router>
      )}
    </>
  );
};

export { Navigation };
